import { CheckboxField, DatePickerField, PhoneNumberField, SelectField, TextField } from 'components';
import { InputType, INPUT_MAP, US_STATES } from './constants';
import merge from 'deepmerge';
import { format } from 'date-fns';

export const renderInput = (data: any) => {
  const { fieldType } = data;
  const fieldPreset = INPUT_MAP[fieldType as keyof typeof INPUT_MAP];
  const field = merge(fieldPreset as any, data) as any;

  switch (field.type) {
    case InputType.EMAIL: {
      return (
        <TextField
          name={field.fieldType}
          label={field.label}
          type="email"
          isRequired={data.required}
          maxLength={field.maxLength}
          autoComplete="on"
          defaultValue={''}
          rules={{ required: { value: data.required, message: field.errorMessage }, ...field.rules }}
          isDisabled={field.isDisabled}
          isReadOnly={field.isDisabled}
          placeholder={field.placeholder}
        />
      );
    }
    case InputType.CHECKBOX: {
      return (
        <CheckboxField
          name={field.fieldType}
          label={field.label}
          isRequired={field.required}
          defaultChecked={field.prechecked ?? false}
          defaultValue={field.prechecked ?? false}
          rules={{ required: { value: field.required, message: field.errorMessage }, ...field.rules }}
        />
      );
    }
    case InputType.SELECT: {
      return (
        <SelectField
          name={field.fieldType}
          label={field.label}
          isRequired={field.required}
          rules={{ required: { value: field.required, message: field.errorMessage }, ...field.rules }}
          selectProps={{ options: US_STATES as any }}
          placeholder={field.placeholder}
        />
      );
    }
    case InputType.PHONE: {
      return (
        <PhoneNumberField
          format="(###) ###-####"
          defaultValue=""
          mask="_"
          name={field.fieldType}
          label={field.label}
          isRequired={field.required}
          placeholder={field.placeholder}
        />
      );
    }
    case InputType.DATE: {
      const currentDate = new Date();
      const minDate = `${currentDate.getFullYear() - 100}-01-01`;
      const maxDate = format(currentDate, 'yyyy-MM-dd');

      return (
        <DatePickerField
          name={field.fieldType}
          label={field.label}
          defaultValue=""
          type="date"
          isRequired={field.required}
          min={minDate}
          max={maxDate}
          rules={{
            ...field.rules,
            required: { value: field.required, message: field.errorMessage },
            min: { value: minDate, message: field.errorMessage },
            max: { value: maxDate, message: field.errorMessage },
          }}
        />
      );
    }
    case InputType.TEXT: {
      return (
        <TextField
          name={field.fieldType}
          label={field.label}
          type="text"
          isRequired={field.required}
          maxLength={field.maxLength}
          autoComplete="on"
          rules={{ ...field.validation, required: { value: field.required, message: field.errorMessage } }}
          placeholder={field.placeholder}
        />
      );
    }
  }
};
